import { useMutation } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import { RecalculateColumnRequest } from "./types";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

export interface RecalculateColumnResponse {
  success?: boolean;
  message?: string;
  requires_confirmation?: boolean;
  confirmation_token?: string;
  execution_id?: string;
  execution_ids?: string[];
  target_execution_id?: string;
  cell_count?: number;
  version?: number;
}

export const useRecalculateColumn = () => {
  const userToken = useAuth()?.userToken ?? "";
  const { workspaceId } = useParams<{ workspaceId: string }>();
  const wid = Number(workspaceId);

  return useMutation<
    RecalculateColumnResponse,
    unknown,
    { tableId: string; sheetId: string; columnId: string } & RecalculateColumnRequest
  >({
    mutationFn: async ({ tableId, sheetId, columnId, ...payload }) => {
      const response = await fetch(
        ENDPOINTS.smart_table_column_recalculate(wid, tableId, sheetId, columnId),
        {
          method: "POST",
          headers: jsonAuthHeaders(userToken),
          body: JSON.stringify(payload),
        },
      );
      return handleResponse(response);
    },
  });
};
